import { IAssetCategory } from '@shared/interfaces/asset-category.interface';
import { ILocation } from '@shared/interfaces/location.interface';
import { IUser } from '@shared/interfaces/user.interface';

export class AssetCategory implements AssetCategory {
  id: string;
  name: string;
  responsibleUsers?: Partial<IUser>[];
  subLocations?: Partial<ILocation>[];

  constructor(partial: Partial<IAssetCategory>) {
    Object.assign(this, partial);
  }
}
